 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"addDevice":"addDevice","basicCheck":"basicCheck","basicFill":"basicFill","bonus":"bonus","channelCheck":"channelCheck","channelFill":"channelFill","costCheck~costFill":"costCheck~costFill","costCheck":"costCheck","costFill":"costFill","developDepartCheck":"developDepartCheck","developDepartFill":"developDepartFill","deviceCheck":"deviceCheck","deviceFill":"deviceFill","engineeringCheck":"engineeringCheck","engineeringFill":"engineeringFill","fahuoCheck~fahuoFill":"fahuoCheck~fahuoFill","fahuoCheck":"fahuoCheck","fahuoFill":"fahuoFill","finance":"finance","funDeviceCheck":"funDeviceCheck","funDeviceFill":"funDeviceFill","fundsCheck":"fundsCheck","fundsFill":"fundsFill","generalProject":"generalProject","homePage":"homePage","income":"income","infoCheck~infoFill":"infoCheck~infoFill","infoCheck":"infoCheck","infoFill":"infoFill","managementPlatform":"managementPlatform","marketIncomeCheck":"marketIncomeCheck","marketIncomeFill":"marketIncomeFill","materialsCheck":"materialsCheck","materialsFill":"materialsFill","materialsPriceFill":"materialsPriceFill","noProjectCheck":"noProjectCheck","noProjectFill":"noProjectFill","penlBossCheck":"penlBossCheck","penlBossFill":"penlBossFill","penlManCheck":"penlManCheck","penlManFill":"penlManFill","penlResearchBonusCheck":"penlResearchBonusCheck","penlResearchBonusFill":"penlResearchBonusFill","penlSaleBonusCheck":"penlSaleBonusCheck","penlSaleBonusFill":"penlSaleBonusFill","personCheck":"personCheck","personFill":"personFill","personnel":"personnel","price":"price","production":"production","productionCheck~productionFill":"productionCheck~productionFill","productionCheck":"productionCheck","productionFill":"productionFill","project":"project","projectFill":"projectFill","pureSaleIncomeCheck":"pureSaleIncomeCheck","pureSaleIncomeFill":"pureSaleIncomeFill","putUnderFee":"putUnderFee","rawExportCheck":"rawExportCheck","rawExportFill":"rawExportFill","rawSaleCheck":"rawSaleCheck","rawSaleFill":"rawSaleFill","rebateCheck":"rebateCheck","rebateFill":"rebateFill","return":"return","sales":"sales","secBarginAreaCheck":"secBarginAreaCheck","secBarginAreaFill":"secBarginAreaFill","secondbargaining":"secondbargaining","setProjectCheck~setProjectFill":"setProjectCheck~setProjectFill","setProjectCheck":"setProjectCheck","setProjectFill":"setProjectFill","setProjectDetail":"setProjectDetail","strategyCheck":"strategyCheck","strategyFill":"strategyFill","taxesCheck":"taxesCheck","taxesFill":"taxesFill","vendors~salaryRule":"vendors~salaryRule","salaryRule":"salaryRule","vendors~tables":"vendors~tables","tables":"tables"}[chunkId]||chunkId) + "." + {"addDevice":"289023cb","basicCheck":"300bde68","basicFill":"3103a983","bonus":"fd88877b","channelCheck":"5114df2d","channelFill":"f60821fe","chunk-0203d294":"93dc85c4","chunk-22bd8c7a":"403e9e2b","chunk-2d0d053d":"f1d466d9","chunk-2d226034":"865db3b1","costCheck~costFill":"13b10045","costCheck":"b7b99083","costFill":"c63f3dde","developDepartCheck":"6a14d5d3","developDepartFill":"fdc91fd0","deviceCheck":"03ced8f2","deviceFill":"096b364e","engineeringCheck":"7a3c5d60","engineeringFill":"1cd2b970","fahuoCheck~fahuoFill":"f52969a2","fahuoCheck":"0e472b1d","fahuoFill":"12cec2b3","finance":"283c34cf","funDeviceCheck":"5da3a08c","funDeviceFill":"67d025ea","fundsCheck":"e4604d72","fundsFill":"0a4a1328","generalProject":"667bdc55","homePage":"b3cd2eaa","income":"ca6aadbd","infoCheck~infoFill":"8b316cf8","infoCheck":"932710fe","infoFill":"5bb255f3","managementPlatform":"e70835d3","marketIncomeCheck":"345b2dcf","marketIncomeFill":"def3b352","materialsCheck":"50c7ab1c","materialsFill":"b9ca0f88","materialsPriceFill":"415a223d","noProjectCheck":"ed5c2ca3","noProjectFill":"9ae98a55","penlBossCheck":"7232fc37","penlBossFill":"5efb80d1","penlManCheck":"5e047eee","penlManFill":"542c4e09","penlResearchBonusCheck":"7916aa0a","penlResearchBonusFill":"750b1a00","penlSaleBonusCheck":"44fa06c6","penlSaleBonusFill":"323dd9a5","personCheck":"11332f65","personFill":"8a799953","personnel":"753a055f","price":"bd46411d","production":"1e0bae25","productionCheck~productionFill":"41776644","productionCheck":"80860ea8","productionFill":"33feab55","project":"20fa8973","projectFill":"cf2b4ee4","pureSaleIncomeCheck":"597d8de1","pureSaleIncomeFill":"9f1d33a0","putUnderFee":"9344f613","rawExportCheck":"5e9b59f5","rawExportFill":"986d8dc6","rawSaleCheck":"476a286e","rawSaleFill":"9431177b","rebateCheck":"731e9e8d","rebateFill":"ee7e4c9a","return":"c7e0610f","sales":"7f9b23d8","secBarginAreaCheck":"81d4ae1d","secBarginAreaFill":"66329cbf","secondbargaining":"6eb18e53","setProjectCheck~setProjectFill":"48db4199","setProjectCheck":"743b94ca","setProjectFill":"cb6ddf0d","setProjectDetail":"44c494e2","strategyCheck":"ea9bc7c9","strategyFill":"0c986706","taxesCheck":"623f2725","taxesFill":"f16595b5","vendors~salaryRule":"c3e5c76d","salaryRule":"39fb3fb8","vendors~tables":"51163478","tables":"40781739"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"addDevice":1,"basicCheck":1,"basicFill":1,"channelCheck":1,"channelFill":1,"chunk-0203d294":1,"chunk-22bd8c7a":1,"costCheck~costFill":1,"costCheck":1,"costFill":1,"developDepartCheck":1,"developDepartFill":1,"deviceCheck":1,"deviceFill":1,"engineeringCheck":1,"engineeringFill":1,"fahuoCheck~fahuoFill":1,"fahuoCheck":1,"fahuoFill":1,"funDeviceCheck":1,"funDeviceFill":1,"fundsCheck":1,"fundsFill":1,"homePage":1,"infoCheck~infoFill":1,"infoCheck":1,"infoFill":1,"marketIncomeCheck":1,"marketIncomeFill":1,"materialsCheck":1,"materialsFill":1,"materialsPriceFill":1,"noProjectCheck":1,"noProjectFill":1,"penlBossCheck":1,"penlBossFill":1,"penlManCheck":1,"penlManFill":1,"penlResearchBonusCheck":1,"penlResearchBonusFill":1,"penlSaleBonusCheck":1,"penlSaleBonusFill":1,"personCheck":1,"personFill":1,"productionCheck~productionFill":1,"productionCheck":1,"productionFill":1,"projectFill":1,"pureSaleIncomeCheck":1,"pureSaleIncomeFill":1,"putUnderFee":1,"rawExportCheck":1,"rawExportFill":1,"rawSaleCheck":1,"rawSaleFill":1,"rebateCheck":1,"rebateFill":1,"secBarginAreaCheck":1,"secBarginAreaFill":1,"setProjectCheck~setProjectFill":1,"setProjectCheck":1,"setProjectFill":1,"setProjectDetail":1,"strategyCheck":1,"strategyFill":1,"taxesCheck":1,"taxesFill":1,"salaryRule":1,"vendors~tables":1,"tables":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"addDevice":"addDevice","basicCheck":"basicCheck","basicFill":"basicFill","bonus":"bonus","channelCheck":"channelCheck","channelFill":"channelFill","costCheck~costFill":"costCheck~costFill","costCheck":"costCheck","costFill":"costFill","developDepartCheck":"developDepartCheck","developDepartFill":"developDepartFill","deviceCheck":"deviceCheck","deviceFill":"deviceFill","engineeringCheck":"engineeringCheck","engineeringFill":"engineeringFill","fahuoCheck~fahuoFill":"fahuoCheck~fahuoFill","fahuoCheck":"fahuoCheck","fahuoFill":"fahuoFill","finance":"finance","funDeviceCheck":"funDeviceCheck","funDeviceFill":"funDeviceFill","fundsCheck":"fundsCheck","fundsFill":"fundsFill","generalProject":"generalProject","homePage":"homePage","income":"income","infoCheck~infoFill":"infoCheck~infoFill","infoCheck":"infoCheck","infoFill":"infoFill","managementPlatform":"managementPlatform","marketIncomeCheck":"marketIncomeCheck","marketIncomeFill":"marketIncomeFill","materialsCheck":"materialsCheck","materialsFill":"materialsFill","materialsPriceFill":"materialsPriceFill","noProjectCheck":"noProjectCheck","noProjectFill":"noProjectFill","penlBossCheck":"penlBossCheck","penlBossFill":"penlBossFill","penlManCheck":"penlManCheck","penlManFill":"penlManFill","penlResearchBonusCheck":"penlResearchBonusCheck","penlResearchBonusFill":"penlResearchBonusFill","penlSaleBonusCheck":"penlSaleBonusCheck","penlSaleBonusFill":"penlSaleBonusFill","personCheck":"personCheck","personFill":"personFill","personnel":"personnel","price":"price","production":"production","productionCheck~productionFill":"productionCheck~productionFill","productionCheck":"productionCheck","productionFill":"productionFill","project":"project","projectFill":"projectFill","pureSaleIncomeCheck":"pureSaleIncomeCheck","pureSaleIncomeFill":"pureSaleIncomeFill","putUnderFee":"putUnderFee","rawExportCheck":"rawExportCheck","rawExportFill":"rawExportFill","rawSaleCheck":"rawSaleCheck","rawSaleFill":"rawSaleFill","rebateCheck":"rebateCheck","rebateFill":"rebateFill","return":"return","sales":"sales","secBarginAreaCheck":"secBarginAreaCheck","secBarginAreaFill":"secBarginAreaFill","secondbargaining":"secondbargaining","setProjectCheck~setProjectFill":"setProjectCheck~setProjectFill","setProjectCheck":"setProjectCheck","setProjectFill":"setProjectFill","setProjectDetail":"setProjectDetail","strategyCheck":"strategyCheck","strategyFill":"strategyFill","taxesCheck":"taxesCheck","taxesFill":"taxesFill","vendors~salaryRule":"vendors~salaryRule","salaryRule":"salaryRule","vendors~tables":"vendors~tables","tables":"tables"}[chunkId]||chunkId) + "." + {"addDevice":"685feedf","basicCheck":"1c153c51","basicFill":"ce5b3856","bonus":"31d6cfe0","channelCheck":"d41f30b9","channelFill":"04dbca73","chunk-0203d294":"048311af","chunk-22bd8c7a":"aab2d2b2","chunk-2d0d053d":"31d6cfe0","chunk-2d226034":"31d6cfe0","costCheck~costFill":"817cfc16","costCheck":"af6dce78","costFill":"ba7beb41","developDepartCheck":"54f6889b","developDepartFill":"e77a14fd","deviceCheck":"6c89b451","deviceFill":"20acc282","engineeringCheck":"b27fd26b","engineeringFill":"e2652a79","fahuoCheck~fahuoFill":"7bb41ed2","fahuoCheck":"ea0eb439","fahuoFill":"c8d3b652","finance":"31d6cfe0","funDeviceCheck":"6c89b451","funDeviceFill":"c1bbbca4","fundsCheck":"5a58f5c7","fundsFill":"395166c7","generalProject":"31d6cfe0","homePage":"3cb4f559","income":"31d6cfe0","infoCheck~infoFill":"f31433ab","infoCheck":"381689a6","infoFill":"559c814f","managementPlatform":"31d6cfe0","marketIncomeCheck":"981da559","marketIncomeFill":"f12d05f8","materialsCheck":"7602b3e5","materialsFill":"911920c6","materialsPriceFill":"b5bf95c8","noProjectCheck":"7b83fb2a","noProjectFill":"1ff334d6","penlBossCheck":"22ff5ab8","penlBossFill":"22ff5ab8","penlManCheck":"6cb54e4f","penlManFill":"c589a28f","penlResearchBonusCheck":"296edc2e","penlResearchBonusFill":"22ff5ab8","penlSaleBonusCheck":"e1b10097","penlSaleBonusFill":"e1b10097","personCheck":"81aa7462","personFill":"1e40b015","personnel":"31d6cfe0","price":"31d6cfe0","production":"31d6cfe0","productionCheck~productionFill":"36f080b1","productionCheck":"047bb192","productionFill":"1fd69c56","project":"31d6cfe0","projectFill":"1c8c998f","pureSaleIncomeCheck":"7c5f6c57","pureSaleIncomeFill":"45cff56e","putUnderFee":"f9fa0ab6","rawExportCheck":"2364e0f4","rawExportFill":"d076b6c2","rawSaleCheck":"9c92eeae","rawSaleFill":"0ece3dfd","rebateCheck":"9b79c32f","rebateFill":"058714f3","return":"31d6cfe0","sales":"31d6cfe0","secBarginAreaCheck":"aa29e3cd","secBarginAreaFill":"a167cbd2","secondbargaining":"31d6cfe0","setProjectCheck~setProjectFill":"ad7288e1","setProjectCheck":"2a4dfa15","setProjectFill":"590cc310","setProjectDetail":"30659548","strategyCheck":"4bb168b7","strategyFill":"b5a96c3c","taxesCheck":"45214abe","taxesFill":"f67c6b10","vendors~salaryRule":"31d6cfe0","salaryRule":"38bf088c","vendors~tables":"1f0a25b2","tables":"b8125d07"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/cvue/Budget-WebPC/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"vendors~app"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
